import axios from 'axios';
import { createClient } from 'contentful';
import resolveResponse from 'contentful-resolve-response';
import _ from 'lodash';
import request, { apiHost } from './utils/request';

export const contentfulFormConfig = {
  include: 8,
  limit: 1000,
  content_type: 'formsContainer'
};

export const contentfulTranslationsConfig = {
  include: 8,
  limit: 1000,
  content_type: 'translations'
};

export const contentfulPagesConfig = {
  include: 8,
  limit: 1000,
  content_type: 'page'
};

// Content types needed before login (app-root translations). Served by the backend's public
// read-only route, which holds the Contentful token; nothing here ever sees it.
const PUBLIC_CONTENT_KINDS = { translations: 'translations' };

// Connection params for post-login Contentful reads come from the backend, not the bundle.
let cfConfigPromise = null;
let cfClientPromise = null;

export const getCfConfig = () => {
  if (!cfConfigPromise) {
    cfConfigPromise = request
      .get('/content/config')
      .then(res => {
        const main = _.get(res, 'data.main');
        if (!main) throw new Error('Contentful config unavailable');
        return main;
      })
      .catch(err => {
        cfConfigPromise = null;
        throw err;
      });
  }
  return cfConfigPromise;
};

// Fire-and-forget warm-up right after login to hide the extra round trip.
export const prefetchCfConfig = () => getCfConfig().catch(() => {});

const getClient = () => {
  if (!cfClientPromise) {
    cfClientPromise = getCfConfig()
      .then(createClient)
      .catch(err => {
        cfClientPromise = null;
        throw err;
      });
  }
  return cfClientPromise;
};

const getPublicContent = async (kind, { locale, include, limit }) => {
  const { data } = await axios.get(`${apiHost}/content/public/${kind}`, {
    params: { locale, include, limit }
  });
  // Same link resolution the Contentful SDK performs on getEntries().
  return {
    ...data,
    items: resolveResponse(data, {
      removeUnresolved: false,
      itemEntryPoints: ['fields']
    })
  };
};

export const getContentfulData = async config => {
  try {
    const publicKind = PUBLIC_CONTENT_KINDS[config.content_type];
    if (publicKind) return await getPublicContent(publicKind, config);
    const client = await getClient();
    return await client.getEntries(config);
  } catch (err) {
    throw new Error(err);
  }
};

export const getRegistrationContentfulData = getContentfulData;

export const getData = data =>
  data && data.items && data.items.length && data.items[0].fields;

export const getMultipleData = data => (data && data.items) || [];
